<template>
    <div>
        <div class="main-page">
            <div class="activity-box" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
                <img :src="item.img" />
                <div class="title">{{ item.name }}</div>
                <div class="more">{{ GLOBAL.lanLocal['clickmore'] }}</div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { doPost } from '../../api/api.js'
import decodeApiLan from '../../api/decodeApiLan.js'
export default {
    name: 'activity',
    data() {
        return {
            id: '',
            isDetail: false,
            innerHeight: 0,
            list: []  //活动列表
        }
    },
    created() {
        this.innerHeight = window.innerHeight - 130
        doPost({
            n: 'AppEx',
            a: 'get_activity_list',
            accountid: this.GLOBAL.userInfo.accountid,
        }).then((res) => {
            const data = decodeApiLan(res, this.GLOBAL.lanArr) //语言包解析匹配
            this.list = data.data.list
        })
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        toDetail(id) {
            this.$emit("detail", id)
        }
    }
}
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.main-page {
    height: 100%;
    width: 100%;
    padding: 60px 10px 80px;
    box-sizing: border-box;

    .activity-box {
        background-color: rgb(27, 32, 38);
        margin-bottom: 12px;

        img {
            width: 100%;
            height: auto;
        }

        .title {
            padding: 4px 8px;
            font-size: 16px;
            color: white;
            text-align: left;
        }

        .more {
            padding: 0 8px 8px;
            font-size: 14px;
            color: #999;
            text-align: left;
        }
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/activity/activity.vue